module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Left-2-ffb6d668a9b510f841dc635bd997a366.svg";